import { Controller } from "@hotwired/stimulus"
import { DateTime } from 'luxon'

export default class extends Controller {
  static targets = [
    "employmentType", "hireDate", "field", "fieldWrapper",
    "servicePeriod", "shiftType", "shiftStart", "shiftEnd", "probationWrapper", "probationDate"
  ]

  connect() {
    this.userEditedEndDate = false
    this.toggleEndDateVisibility()
    this.update()
  }

  update() {
    const type = this.employmentTypeTarget?.value
    const hireDate = this.hireDateTarget?.value

    if (!type) return

    const isProbation = type === "probation"
    const isContract = type === "contract"

    this.toggleEndDateVisibility()

    if (!this.userEditedEndDate) {
      if (isProbation) {
        this.applyHireDateForProbation()
      } else if (isContract && hireDate) {
        const date = new Date(hireDate)
        const contractYear = date.getMonth() + 1 > 6 ? date.getFullYear() + 1 : date.getFullYear()
        const formatted = `${contractYear}-06-30`
        this.fieldTarget.value = formatted
      }
    }

    this.updateServicePeriod()
  }


  markEndDateManualEdit() {
    this.userEditedEndDate = true
    this.updateServicePeriod()
  }

  updateServicePeriod() {
    if (!this.hasServicePeriodTarget) return;

    const hireDateStr = this.hireDateTarget?.value
    const endDateStr = this.fieldTarget?.value

    if (!hireDateStr || !endDateStr) {
      this.servicePeriodTarget.value = ''
      return
    }

    const hireDate = DateTime.fromISO(hireDateStr)
    const endDate = DateTime.fromISO(endDateStr)

    if (!hireDate.isValid || !endDate.isValid) {
      this.servicePeriodTarget.value = ''
      return
    }

    let { years, months, days } = endDate.diff(hireDate, ['years', 'months', 'days']).toObject()

    years = Math.floor(years || 0)
    months = Math.floor(months || 0)
    days = Math.floor(days || 0)

    const parts = []
    if (years > 0) parts.push(`${years} year${years > 1 ? 's' : ''}`)
    if (months > 0) parts.push(`${months} month${months > 1 ? 's' : ''}`)
    if (days > 0) parts.push(`${days} day${days > 1 ? 's' : ''}`)

    this.servicePeriodTarget.value = parts.join(', ')
  }

  updateShiftTime() {
    if (!this.hasShiftTypeTarget || !this.hasShiftStartTarget || !this.hasShiftEndTarget) return;

    const selected = parseInt(this.shiftTypeTarget.value)
    console.log(selected);
    switch (selected) {
      case 9: // 10 am to 7 pm
        this.shiftStartTarget.value = "10:00"
        this.shiftEndTarget.value = "19:00"
        this.shiftStartTarget.readOnly = true
        this.shiftEndTarget.readOnly = true
        break
      case 12: // 10 am to 10 pm
        this.shiftStartTarget.value = "10:00"
        this.shiftEndTarget.value = "22:00"
        this.shiftStartTarget.readOnly = true
        this.shiftEndTarget.readOnly = true
        break
      case 4: // 4 Hr – allow manual entry
        this.shiftStartTarget.value = ""
        this.shiftEndTarget.value = ""
        this.shiftStartTarget.readOnly = false
        this.shiftEndTarget.readOnly = false
        break
      default:
        this.shiftStartTarget.value = ""
        this.shiftEndTarget.value = ""
        this.shiftStartTarget.readOnly = true
        this.shiftEndTarget.readOnly = true
    }
  }
  validateShiftTime() {
    if (!this.hasShiftStartTarget || !this.hasShiftEndTarget) return;

    const startTime = this.shiftStartTarget.value
    const endTime = this.shiftEndTarget.value

    // Skip if either field is empty
    if (!startTime || !endTime) return

    const start = new Date(`1970-01-01T${startTime}:00`)
    const end = new Date(`1970-01-01T${endTime}:00`)

    if (end <= start) {
      alert("Shift End Time must be greater than Shift Start Time.")
      this.shiftEndTarget.value = ""
      this.shiftEndTarget.focus()
    }
  }


  toggleEndDateVisibility() {
    const type = this.employmentTypeTarget?.value

    const showEndDate = ["contract", "probation"].includes(type)
    const showProbation = type === "probation"

    if (this.hasFieldWrapperTarget) {
      this.fieldWrapperTarget.classList.toggle('d-none', !showEndDate)
    }
    
    if (this.hasProbationWrapperTarget) {
      this.probationWrapperTarget.classList.toggle('d-none', !showProbation)
    }
  }
  applyProbationDate(event) {
    const probationDate = event.target.value
    const type = this.employmentTypeTarget?.value

    if (type === "probation" && probationDate && !this.userEditedEndDate) {
      this.fieldTarget.value = probationDate
      this.updateServicePeriod()
    }
  }
  applyHireDateForProbation() {
    const type = this.employmentTypeTarget?.value
    const hireDateStr = this.hireDateTarget?.value
    if (type === "probation" && hireDateStr && !this.userEditedEndDate) {
      const hireDate = DateTime.fromISO(hireDateStr)
      const probationEnd = hireDate.plus({ months: 3 }).toISODate()
      this.probationDateTarget.value = probationEnd
      this.fieldTarget.value = probationEnd
      this.updateServicePeriod()
    }
  }


}
